"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherAdjustmentCode = void 0;
var OtherAdjustmentCode;
(function (OtherAdjustmentCode) {
    OtherAdjustmentCode["ProcessTime"] = "500";
    OtherAdjustmentCode["LateFiling"] = "501";
    OtherAdjustmentCode["LegalActionDelayFee"] = "503";
    OtherAdjustmentCode["OtherAdjustment"] = "506";
    OtherAdjustmentCode["DEFSLOPT1DT"] = "507";
    OtherAdjustmentCode["OngoingResponsibilities"] = "513";
    OtherAdjustmentCode["FireOtherInsurablePerilDamage"] = "517";
    OtherAdjustmentCode["DelayInSale"] = "520";
    OtherAdjustmentCode["OngoingLoansAdminRentAdjustment"] = "524";
    OtherAdjustmentCode["DEFSLOPT2DT"] = "530";
    OtherAdjustmentCode["OtherAdjustment2"] = "998";
})(OtherAdjustmentCode = exports.OtherAdjustmentCode || (exports.OtherAdjustmentCode = {}));
